export const flightTaskPage = {
    canceled: ['ОТМЕНЁН', 'CANCELED'],
    flightTaskList: ['Список полётных заданий', 'Flight task list'],
    noFlightTasks: ['Полётных заданий нет', 'There are not any flight tasks'],
    openTask: ['Открыть задание', 'Open task'],
    showTaskTitle: ['Показать титульную страницу задания', 'Show task title'],

    action: {
        dayAgo: ['{{action}} день назад', '{{action}} a day ago'],
        daysAgo: ['{{action}} {{diffDays}} дней назад', '{{action}} {{diffDays}} days ago'],
        hourAgo: ['{{action}} час назад', '{{action}} an hour ago'],
        hoursAgo: ['{{action}} {{diffHours}} часов назад', '{{action}} {{diffHours}} hours ago'],
        justNow: ['{{action}} только что', 'Just {{action}}'],
        minuteAgo: ['{{action}} минуту назад', '{{action}} a minute ago'],
        minutesAgo: ['{{action}} {{diffMinutes}} минут назад', '{{action}} {{diffMinutes}} minutes ago'],
    },
};
